import { render } from "./DetailsSubsection.vue?vue&type=template&id=0e3258cd&ts=true"
import script from "./DetailsSubsection.vue?vue&type=script&lang=ts"
export * from "./DetailsSubsection.vue?vue&type=script&lang=ts"

import "./DetailsSubsection.vue?vue&type=style&index=0&id=0e3258cd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__